module.exports = __webpack_public_path__ + "img/vertical_3_5_8004.ca61458e.png";